export default "<label *ngIf=\"showMessage\" #error [hidden]=\"!message\" class=\"custom-text-weight-normal mt-1\">{{message}}</label>\n";